module.exports = __webpack_public_path__ + "static/xy-histogram-with-mean-aggregation-4a45789071639e9ceb1ff8e749ac7377.png";